import Vue from 'vue';
import Vuex from 'vuex';

import * as firebase from "firebase";


Vue.use(Vuex);

export const store = new Vuex.Store({

    state: {
        user: null,
        error: null,
        pointTexts: [],
        pointPics: [],
        pointAudio: [],
        pointVideo: [],
        pointQuestions: [],
        points: [],
        maxTextId: null,
        maxQuestionId: null,
        maxPicId: null,
        maxSpotId: null,
        loading: false
    },
    mutations: {
        setLoading(state, payload) {
            state.loading = payload;
        },
        setUser(state, payload) {
            state.user = payload;
        },
        setError(state, payload) {
            state.error = payload;
        },
        setTexts(state, payload) {
            state.pointTexts = payload;
        },
        setPics(state, payload) {
            state.pointPics = payload;
        },
        setAudio(state, payload) {
            state.pointAudio = payload;
        },
        setVideo(state, payload) {
            state.pointVideo = payload;
        },
        setQuestion(state, payload) {
            state.pointQuestions = payload;
        },
        setPoints(state, payload) {
            state.points = payload;
        },
        setMaxTextId(state, payload) {
            state.maxTextId = payload;
        },
        setMaxPicId(state, payload) {
            state.maxPicId = payload;
        },
        setMaxQuestionId(state, payload) {
            state.maxQuestionId = payload;
        },
        setMaxSpotId(state, payload) {
            state.maxSpotId = payload;
        }
    },
    actions: {
        createSpot({
            commit
        }, payload) {
            let updateobj = {};
            updateobj = payload;
            return firebase.database().ref('interestPoints').push(updateobj);
        },
        createText({
            commit
        }, payload) {
            let updateobj = {};
            updateobj = payload;
            return firebase.database().ref('infoText').push(updateobj);
        },
        reformQue({ commit }, payload) {
            let updateobj = {};
            updateobj = {
                question: payload.question,
                options: payload.options,
                correct: payload.correct,
                language: payload.language,
                id: payload.id,
                school_type: payload.school_type,
                theme: payload.theme,
                createdBy: payload.createdBy
            };
            return firebase.database().ref('questions').push(updateobj);
        },
        createQuestion({
            commit
        }, payload) {
            let updateobj = {};
            updateobj = payload;
            return firebase.database().ref('questions').push(updateobj);
        },
        reformText({
            commit
        }, payload) {
            let updateobj = {};
            updateobj = payload;
            return firebase.database().ref('infoText').push(updateobj);
        },
        reformPic({
            commit
        }, payload) {
            commit('setLoading', true);
            const filename = payload.imageName;
            const pushobj = {
                infoPicture: payload.imageUrl,
                image: payload.image,
                infoPtitle: payload.infoPTitle,
                infoPAbbr: payload.infoPAbbr,
                infoPPeriod: payload.infoPPeriod,
                infoPSchType: payload.infoPSchType,
                infoPSource: payload.infoPSource,
                infoPID: payload.infoPID,
                interestPoint: payload.interestPoint,
                infoPLang: payload.infoPLang,
                createdBy: payload.createdBy
            };
            let key;
            if (payload.image) {
                firebase.database().ref('infoPic').push(pushobj)
                    .then((data) => {
                        key = data.key
                        return key
                    })
                    .then(key => {

                        const ext = filename.slice(filename.lastIndexOf('.'));
                        return firebase.storage().ref('/infoPics/images/' + payload.infoPID + '/image' + ext).put(pushobj.image);
                    })
                    .then(filedata => {


                        return firebase.storage().ref(filedata.metadata.fullPath).getDownloadURL().then(function (url) {

                            commit('setLoading', false);
                            return firebase.database().ref('infoPic').child(key).update({
                                infoPicture: url
                            })
                        });

                    })
                    .catch((error) => {

                        commit('setLoading', false);
                    });
            } else {
                firebase.database().ref('infoPic').push(pushobj)
                commit('setLoading', false);
            }

        },
        translateText({
            commit
        }, payload) {
            let updateobj = {};
            updateobj = payload;
            return firebase.database().ref('infoText').push(updateobj);

        },
        translateQue({ commit }, payload) {
            let updateobj = {};
            updateobj = {
                question: payload.question,
                options: payload.options,
                correct: payload.correct,
                language: payload.language,
                id: payload.id,
                school_type: payload.school_type,
                theme: payload.theme,
                createdBy:payload.createdBy
            };
            return firebase.database().ref('questions').push(updateobj);
        },
        translatePic({
            commit
        }, payload) {
            commit('setLoading', true);
            const filename = payload.imageName;
            const pushobj = {
                infoPicture: payload.imageUrl,
                infoPtitle: payload.infoPtitle,
                infoPAbbr: payload.infoPAbbr,
                infoPPeriod: payload.infoPPeriod,
                infoPSchType: payload.infoPSchType,
                infoPSource: payload.infoPSource,
                infoPID: payload.infoPID,
                interestPoint: payload.interestPoint,
                infoPLang: payload.infoPLang,
                createdBy:payload.createdBy
            };
            let key;
            if (payload.image) {
                firebase.database().ref('infoPic').push(pushobj)
                    .then((data) => {
                        key = data.key
                        return key
                    })
                    .then(key => {

                        const ext = filename.slice(filename.lastIndexOf('.'));
                        return firebase.storage().ref('/infoPics/images/' + payload.infoPID + '/image' + ext).put(pushobj.image);
                    })
                    .then(filedata => {

                        return firebase.storage().ref(filedata.metadata.fullPath).getDownloadURL().then(function (url) {

                            commit('setLoading', false);
                            return firebase.database().ref('infoPic').child(key).update({
                                infoPicture: url
                            })
                        });

                    })
                    .catch((error) => {

                        commit('setLoading', false);
                    });
            } else {
                firebase.database().ref('infoPic').push(pushobj)
                commit('setLoading', false);
            }

        },
        updateQue({ commit }, payload) {
            let updateobj = {};
            updateobj = {
                question: payload.question,
                options: payload.options,
                correct: payload.correct,
                language: payload.language,
                id: payload.id,
                school_type: payload.school_type,
                theme: payload.theme,
                lastChangedBy:payload.lastChangedBy
            };
            return firebase.database().ref('questions')
                .child(payload.key).update(updateobj);
        },
        updateText({
            commit
        }, payload) {
            let updateobj = {};
            updateobj = payload;
            return firebase.database().ref('infoText').child(payload.id).update(updateobj);
        },
        deleteText({
            commit
        }, payload) {
            return firebase.database().ref('infoText').child(payload.id).remove();
        },

        deletePicture({
            commit
        }, payload) {
            return firebase.database().ref('infoPic').child(payload.id).remove();
        },
        deleteQuestion({
            commit
        }, payload) {
            return firebase.database().ref('questions').child(payload.key).remove();
        },

        loadSpotContent({
            commit
        }, payload) {
            commit('setLoading', true);
            var dbText = firebase.database().ref('infoText');
            dbText.orderByChild('interestPoint').equalTo(payload).once("value", function (snapshot) {

                var obj = snapshot.val()

                const texts = [];
                for (let key in obj) {
                    texts.push({
                        id: key,
                        interestPoint: obj[key].interestPoint,
                        infoTID: obj[key].infoTID,
                        infoTLang: obj[key].infoTLang,
                        infoSchType: obj[key].infoTSchType,
                        infoTPeriod: obj[key].infoTPeriod,
                        infoTSource: obj[key].infoTSource,
                        infoTText: obj[key].infoTText,
                        infoTTitle: obj[key].infoTTitle,
                        infoTAbbr: obj[key].infoTAbbr,
                        infoTVoice: obj[key].infoTVoice,
                        createdBy:obj[key].createdBy,
                        lastChangedBy:obj[key].lastChangedBy
                    });
                }

                commit('setTexts', texts);

            });

            var dbPic = firebase.database().ref('infoPic');
            dbPic.orderByChild('interestPoint').equalTo(payload).once("value", function (snapshot) {

                var obj = snapshot.val()

                const pics = [];
                for (let key in obj) {

                    pics.push({
                        id: key,
                        interestPoint: obj[key].interestPoint,
                        infoPID: obj[key].infoPID,
                        infoPLang: obj[key].infoPLang,
                        infoPSchType: obj[key].infoPSchType,
                        infoPPeriod: obj[key].infoPPeriod,
                        infoPSource: obj[key].infoPSource,
                        infoPAge: obj[key].infoPAge,
                        infoPtitle: obj[key].infoPtitle,
                        infoPVoice: obj[key].infoPVoicem,
                        infoPAbbr: obj[key].infoPAbbr,
                        infoPicture: obj[key].infoPicture,
                        createdBy:obj[key].createdBy,
                        lastChangedBy:obj[key].lastChangedBy
                    });
                }

                commit('setPics', pics);

            });

            var dbQuestions = firebase.database().ref('questions');
            dbQuestions.orderByChild('theme').equalTo(payload).once("value", function (snapshot) {

                var obj = snapshot.val()

                const ques = [];
                for (let key in obj) {
                    ques.push({
                        key: key,
                        correct: obj[key].correct,
                        id: obj[key].id,
                        language: obj[key].language,
                        options: obj[key].options,
                        question: obj[key].question,
                        school_type: obj[key].school_type,
                        point: obj[key].theme,
                        createdBy:obj[key].createdBy,
                        lastChangedBy:obj[key].lastChangedBy
                    });
                }

                commit('setQuestion', ques);
                commit('setLoading', false);
            });
        },
        getPoints({
            commit
        }) {
            commit('setLoading', true);
            var iP = firebase.database().ref('interestPoints');
            iP.on("value", function (snapshot) {

                var obj = snapshot.val()

                const points = [];
                for (let key in obj) {

                    points.push({
                        id: obj[key].id,
                        title: obj[key].title,
                        coord: {
                            x: obj[key].coord.x,
                            y: obj[key].coord.y,
                            z: obj[key].coord.z
                        },
                        createdBy:obj[key].createdBy

                    });
                }

                commit('setPoints', points);
                commit('setLoading', false);
            });
            firebase.database().ref('infoText').orderByChild('infoTID').limitToLast(1).on("value", function (snapshot) {
                var obj = snapshot.val();

                for (let key in obj) {
                    var max = obj[key].infoTID;
                }

                commit('setMaxTextId', max);
            });
            firebase.database().ref('infoPic').orderByChild('infoPID').limitToLast(1).on("value", function (snapshot) {
                var obj = snapshot.val();

                for (let key in obj) {
                    var max = obj[key].infoPID;
                }

                commit('setMaxPicId', max);
            });
            firebase.database().ref('interestPoints').orderByChild('id').limitToLast(1).on("value", function (snapshot) {
                var obj = snapshot.val();

                for (let key in obj) {
                    var maxP = obj[key].id;
                }
                commit('setMaxSpotId', maxP);
            });
            firebase.database().ref('questions').orderByChild('id').limitToLast(1).on("value", function (snapshot) {
                var obj = snapshot.val();

                for (let key in obj) {
                    var max = obj[key].id;
                }
                commit('setMaxQuestionId', max);
            });

        },
        signUser({
            commit
        }, payload) {
            commit('setLoading', true);
            var found = false;
            const credentials = [{
                email: 'nastazia@nile.com',
                password: 'nastazia313',
            },
            {
                email: 'areth@nile.com',
                password: 'areth313',
            },
            {
                email: 'vidakis_eva@nile.com',
                password: 'eva313',
            },
            {
                email: 'klelia@nile.com',
                password: 'klelia313',
            },
            {
                email: 'barianos@nile.com',
                password: 'bar313',
            },
            {
                email: 'nv@nile.com',
                password: 'nv313',
            },{
                email: 'test@nile.com',
                password: 'test313',
            }


            ];
            for (let i = 0; i < credentials.length; i++) {
                if (payload.email === credentials[i].email && payload.password === credentials[i].password) {
                    found =true;
                }

            }
            if (found) {
                commit('setUser', payload);
                commit('setLoading', false);
            } else {
                commit('setError', 'wrong credentials');
                commit('setLoading', false);
            }
        },
        createPic({
            commit
        }, payload) {
            const filename = payload.imageName;
            const pushobj = {
                infoPicture: "",
                image: payload.image,
                infoPtitle: payload.infoPTitle,
                infoPAbbr: payload.infoPAbbr,
                infoPPeriod: payload.infoPPeriod,
                infoPSchType: payload.infoPSchType,
                infoPSource: payload.infoPSource,
                infoPID: payload.infoPID,
                interestPoint: payload.interestPoint,
                infoPLang: payload.infoPLang,
                createdBy:payload.createdBy
            };
            let key;
            firebase.database().ref('infoPic').push(pushobj)
                .then((data) => {
                    key = data.key
                    return key
                })
                .then(key => {

                    const ext = filename.slice(filename.lastIndexOf('.'));
                    return firebase.storage().ref('/infoPics/images/' + payload.infoPID + '/image' + ext).put(pushobj.image);
                })
                .then(filedata => {

                    return firebase.storage().ref(filedata.metadata.fullPath).getDownloadURL().then(function (url) {

                        return firebase.database().ref('infoPic').child(key).update({
                            infoPicture: url
                        })
                    });

                })
                .catch((error) => {

                });
        },

        updatePic({
            commit
        }, payload) {


            const filename = payload.imageName;
            const updateobj = {
                infoPAbbr: payload.infoPAbbr,
                infoPtitle: payload.infoPTitle,
                infoPicture: payload.imageUrl,
                image: payload.image,
                infoPPeriod: payload.infoPPeriod,
                infoPSource: payload.infoPSource,
                lastChangedBy:payload.lastChangedBy
            }
            let key;
            if (payload.image) {
                firebase.database().ref('infoPic/' + payload.id).update(updateobj)
                    .then(key => {

                        const ext = filename.slice(filename.lastIndexOf('.'));
                        return firebase.storage().ref('/infoPics/images/' + payload.infoPID + '/image' + ext).put(updateobj.image);
                    })
                    .then(filedata => {

                        return firebase.storage().ref(filedata.metadata.fullPath).getDownloadURL().then(function (url) {

                            return firebase.database().ref('infoPic').child(payload.id).update({
                                infoPicture: url
                            })
                        });

                    })
                    .catch((error) => {


                    });
            } else {
                firebase.database().ref('infoPic/' + payload.id).update(updateobj)
            }
        },
        clearData({ commit }) {

            const empty = [];
            commit('setTexts', empty);
            commit('setPics', empty);
        },
        clearError({
            commit
        }) {
            commit('setError', null);
        }

    },
    getters: {
        loading(state) {
            return state.loading;
        },
        user(state) {
            return state.user;
        },
        error(state) {
            return state.error;
        },
        pointTexts(state) {
            return state.pointTexts;
        },
        pointPics(state) {
            return state.pointPics;
        },
        pointQuestions(state) {
            return state.pointQuestions;
        },
        pointAudio(state) {
            return state.pointAudio;
        },
        pointVideo(state) {
            return state.pointVideo;
        },
        points(state) {
            return state.points;
        },
        maxTextId(state) {
            return state.maxTextId;
        },
        maxPicId(state) {
            return state.maxPicId;
        },
        maxQuestionId(state) {
            return state.maxQuestionId;
        },
        maxSpotId(state) {
            return state.maxSpotId;
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js